import React from "react";
import classes from "./DeleteContactDetail.module.css";
import API from "../../utils/api";
import RenderToast from "../../components/RenderToast";

export default function DeleteContactDetailModal({
  messages = { ids: [], names: [] },
  onClose,
  onDeleted,
}) {
  const token = localStorage.getItem("authToken") || "";

  const handleDelete = async () => {
    if (!messages.ids || messages.ids.length === 0) return;

    try {
      const formData = new URLSearchParams();
      if (messages.ids.length > 1) {
        formData.append("action", "bulk_delete");
        formData.append("ids", JSON.stringify(messages.ids));
      } else {
        formData.append("action", "delete");
        formData.append("id", messages.ids[0]);
      }

      const response = await fetch(`${API.base}/contact_messages.php`, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Failed to delete");

      RenderToast({ type: "success", message: "Contact message deleted" });
      if (onDeleted) onDeleted();
      if (onClose) onClose();
    } catch (err) {
      RenderToast({ type: "error", message: err.message });
    }
  };

  if (!messages || !messages.ids || messages.ids.length === 0) return null;

  return (
    <div className={classes.backdrop} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <h3>Confirm Delete</h3>
        <p>
          Are you sure you want to delete{" "}
          {messages.ids.length === 1 && messages.names.length > 0 && (
            <strong className={classes.userName}>{messages.names[0]}</strong>
          )}{" "}
          {messages.ids.length} contact message
          {messages.ids.length > 1 ? "s" : ""}?
        </p>

        <div className={classes.buttons}>
          <button className={classes.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button className={classes.deleteBtn} onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
